import { NgwWebmapLayerAdapter } from '@nextgis/ngw-kit';

import { Scene3DLayerItem } from './Scene3DLayerItem';

import type { Scene3DTreeItem } from './interfaces';
import type { ResourceCls } from '@nextgis/ngw-connector';
import type { NgwWebmapAdapterOptions } from '@nextgis/ngw-kit';

export class Scene3DAdapter extends NgwWebmapLayerAdapter {
  // @ts-ignore
  NgwWebmapItem = Scene3DLayerItem;

  webmapClassName = 'scene_3d';

  async addLayer(options: NgwWebmapAdapterOptions): Promise<any> {
    this.options = { ...this.options, ...options };
    this.layer = await this._getWebMapLayerItem();
    return this.layer;
  }

  async getIdentificationIds(): Promise<number[]> {
    const visibleLayers: number[] = [];

    let deps = this.getDependLayers() as Scene3DLayerItem[];
    deps = deps.sort((a, b) => b.id - a.id);
    for (const x of deps) {
      if ('classification_layer' in x.item || 'resource_cls' in x.item) {
        // @ts-expect-error missing the following properties
        const item = x.item as Scene3DTreeItem;
        const clsForIdentification: ResourceCls[] = [
          'qgis_vector_style',
          'mapserver_style',
        ];
        let id: number | undefined = undefined;
        if (item.classification_layer) {
          id = item.classification_layer.id;
        } else if (
          clsForIdentification.includes(item.resource_cls as ResourceCls)
        ) {
          id = item.parent;
        }
        if (id !== undefined) {
          if (x.properties.get('visibility')) {
            visibleLayers.push(id);
          }
        }
      }
    }

    return visibleLayers;
  }
}
